<mat-dialog-content class="w-100 h-100 overflow-hidden">
  <div class="pt-5 container">
    <div class="infoBox">
      <img
        class="infoBox__logo"
        ngSrc="../../../assets/attractor-logo-stroke.1d6468d6.svg"
        alt="attractor-logo"
        height="345"
        width="345" />
      <h1>Уважаемый пользователь!</h1>
      <p>
        На данный момент, в CRM системе проводятся технические работы <br />
        <span class="infoBox__highlight"
          >В ближайшее время все заработает. Возвращайтесь чуть позже.</span
        >
      </p>
      <span class="infoBox__commandText"
        >С уважением, команда Attractor School.</span
      >
    </div>
  </div>
</mat-dialog-content>
